import { render, staticRenderFns } from "./bodyTableDdtFornitore.vue?vue&type=template&id=4f3129ce&scoped=true"
import script from "./bodyTableDdtFornitore.vue?vue&type=script&lang=js"
export * from "./bodyTableDdtFornitore.vue?vue&type=script&lang=js"
import style0 from "./bodyTableDdtFornitore.vue?vue&type=style&index=0&id=4f3129ce&prod&lang=scss"
import style1 from "./bodyTableDdtFornitore.vue?vue&type=style&index=1&id=4f3129ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3129ce",
  null
  
)

export default component.exports